import './index.css'

import React, { Component } from 'react'
import RecipientTag from '../recipient-tag'
type Props = {
  recipients: Array<any>
  onClick: (...args: Array<any>) => any
  onInplaceEdit?: (...args: Array<any>) => any
}

/**
 * Recipient list component that displays a list of recipients as tags
 * Provides click handlers for recipient removal and in-place editing
 * @param recipients - Array of recipient objects to display
 * @param onClick - Callback when a recipient is clicked (typically for removal)
 * @param onInplaceEdit - Optional callback for in-place editing of recipients
 */
class RecipientList extends Component<Props> {
  render(): null | React.ReactElement<'ul'> {
    if (this.props.recipients.length === 0) return null
    const list = this.props.recipients.map((recipient, index) => {
      return (
        <li key={index}>
          <RecipientTag
            index={index}
            recipient={recipient}
            onClick={() => this.props.onClick(recipient, index)}
            onInplaceEdit={() => {
              if (this.props.onInplaceEdit)
                this.props.onInplaceEdit(recipient, index)
            }}
          />
        </li>
      )
    })
    return <ul className="RecipientList">{list}</ul>
  }
}

export default RecipientList
